// Home.jsx
// The main landing page - first thing visitors see

import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import '../styles/Home.css';

function Home() {
  // Get translations
  const { t } = useLanguage();

  return (
    <div className="home">
      {/* Hero Section - The big banner at top */}
      <section className="hero">
        <div className="hero-content">
          {/* Left Side - Text Content */}
          <div className="hero-text">
            <h1>{t.hero.title}</h1>
            <p className="tagline">{t.hero.tagline}</p>
            <p className="hero-description">{t.hero.description}</p>

            {/* Call-to-Action Buttons */}
            <div className="cta-buttons">
              {/* 
                Link vs <a> tag:
                - <a> causes full page reload
                - Link from react-router-dom changes page without reload
                This makes navigation super fast!
              */}
              <Link to="/services" className="btn btn-primary">
                {t.hero.viewServices}
              </Link>
              <Link to="/contact" className="btn btn-secondary">
                {t.hero.contactUs}
              </Link>
            </div>
          </div>

          {/* Right Side - Image Placeholder */}
          <div className="hero-image">
            <div className="hero-image-placeholder">
              👗
            </div>
          </div>
        </div>
      </section>

      {/* Quick Info Section */}
      <section className="quick-info">
        <div className="info-container">
          <div className="info-card">
            <div className="info-icon">📍</div>
            <h3>Visit Us</h3>
            <p>Chinchwad, Pimpri-Chinchwad</p>
          </div>
          <div className="info-card">
            <div className="info-icon">📞</div>
            <h3>Call Us</h3>
            <p>+91 98504 88855</p>
            <p>+91 90110 44937</p>
          </div>
          <div className="info-card">
            <div className="info-icon">🕐</div>
            <h3>Working Hours</h3>
            <p>Mon-Sat: 10 AM - 7 PM</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;

/*
REACT CONCEPTS IN THIS PAGE:

1. COMPONENT STRUCTURE:
   - Import dependencies at top
   - Define function component
   - Return JSX
   - Export at bottom

2. JSX:
   - Looks like HTML but it's JavaScript
   - Use {} to insert JavaScript expressions
   - className instead of class (because class is reserved in JS)

3. ROUTING:
   - Link component from react-router-dom
   - to="/services" navigates to services page
   - No page reload = faster, smoother experience

4. SEMANTIC HTML:
   - <section> groups related content
   - <h1>, <h3> for proper heading hierarchy
   - Helps with SEO and accessibility
*/
